<template>
  <div class="room-setting-join-component">
    <div class="room-setting-content-box">
      <h6 class="room-setting-content-title">{{ $t("setting.join.role.title") }}</h6>
      <div class="room-setting-content-text-box">
        <p class="room-setting-content-text">{{ $t("setting.join.role.message", { '0' : enterRole === 'participant' ? $t('common.participant') : $t('common.emcee')}) }}</p>
      </div>
      <div class="room-setting-input-box"
           :class="{ disable : useWaitingRoom }"
      >
            <label class="room-setting-label"
                   v-for="(role, i) in roleList"
                   :key="i">
              <input type="radio" class="room-setting-radio" name="setEntryAuth"
                     v-model="enterRole"
                     :value="role.value"
              >
              <span>{{ role.title }}</span>
            </label>
      </div>
      <div v-if="useWaitingRoom" class="room-setting-content-text-box">
        <p class="room-setting-content-text use-waiting-room">{{ $t("setting.waitingRoom.text") }}</p>
      </div>
    </div>
    <div class="room-setting-content-box">
      <h6 class="room-setting-content-title">{{ $t("setting.join.device.title") }}</h6>
      <div class="room-setting-content-text-box">
        <p class="room-setting-content-text">{{ $t("setting.join.device.text") }}</p>
      </div>
      <div class="room-setting-input-box">
        <div class="room-set-block-btn-box device-join-select">
          <ul>
            <li v-for="(device, i) in deviceList"
                :key="i" :class="{ selected : params.defaultDeviceType == device.value }"
                :name="device.value"
                @click="CHANGE_SETTING_DATA({type: 'defaultDeviceType', value: device.value})">
              <button class="room-set-block-btn" tabindex="1">{{ device.title }}</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="room-setting-content-box">
      <h6 class="room-setting-content-title">{{ $t("setting.join.default.title") }}</h6>
      <div class="room-setting-content-text-box">
        <p class="room-setting-content-text">{{ $t("setting.join.default.text") }}</p>
      </div>
      <div class="room-setting-input-box">
        <label class="room-setting-label">
          <input type="checkbox" name="defaultRoleCamera" class="room-setting-radio"
                 v-model="isCameraOn"
                 @click="CHANGE_SETTING_DATA({type: 'defaultRoleCamera', value: !isCameraOn})">
          <span>{{ $t("common.device.camera") }}</span>
        </label>
        <label class="room-setting-label">
          <input type="checkbox" name="defaultRoleMic" class="room-setting-radio"
                 v-model="isMicOn"
                 @click="CHANGE_SETTING_DATA({type: 'defaultRoleMic', value: !isMicOn})">
          <span>{{ $t("common.device.mic") }}</span>
        </label>
      </div>
    </div>
    <div class="room-setting-content-box">
      <h6 class="room-setting-content-title">{{ $t("setting.join.rejoin.title") }}</h6>
      <div class="room-setting-content-text-box">
        <p class="room-setting-content-text">{{ $t("setting.join.rejoin.text") }}</p>
      </div>
      <div class="room-setting-input-box">
        <label class="room-setting-label">
          <input type="checkbox" name="defaultRoleReset" class="room-setting-radio"
                 v-model="isResetRole"
                 @click="CHANGE_SETTING_DATA({type: 'defaultRoleReset', value: !isResetRole})">
          <span>{{ $t("setting.join.rejoin.init") }}</span>
        </label>
      </div>
    </div>
    <div class="room-setting-content-box">
      <h6 class="room-setting-content-title">{{ $t("setting.waitingRoom.title") }}</h6>
      <div class="room-setting-content-text-box">
        <p class="room-setting-content-text">{{ $t("setting.waitingRoom.text") }}</p>
      </div>
      <div class="room-setting-input-box">
        <label class="room-setting-label">
          <input type="checkbox" name="entryWaitingRoom" class="room-setting-radio useEntryWaitingRoom"
                 v-model="useWaitingRoom"
                 @click="CHANGE_SETTING_DATA({type: 'useWaitingMode', value: !useWaitingRoom})">
          <span>{{ $t("setting.waitingRoom.use") }}</span>
        </label>
      </div>
      <div class="room-setting-input-box sub"
           :class="{ disable : !useWaitingRoom }">
        <label class="room-setting-label">
          <input type="checkbox" name="entryWaitingRoom" class="room-setting-radio useEntryWaitingRoom"
                 v-model="isDeviceRequired"
                 @click="CHANGE_SETTING_DATA({type: 'isDeviceRequired', value: !isDeviceRequired})">
          <span>{{ $t("setting.waitingRoom.essential") }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  data(){
    return{
      roleList: [
        {value : 'participant', title: this.$t('common.participant')},
        {value : 'emcee', title: this.$t('common.emcee')},
      ],
      enterRole: '',
      joinDevice: 'all',
      deviceList: [
        {value : 'all', title: this.$t('setting.join.device.all')},
        {value : 'pc', title: 'PC'},
        {value : 'mobile', title: this.$t('setting.join.device.mobile')},
      ],
      isMicOn: false,
      isCameraOn: false,
      isResetRole: false,
      useWaitingRoom: false,
      isDeviceRequired: false,
    }
  },
  computed:{
    ...mapGetters('roomSetting', ['params']),
  },
  mounted(){
    this.setDefault()
  },
  watch: {
    useWaitingRoom: function() {
      if (this.useWaitingRoom) {
        this.enterRole = this.roleList[0].value;
      }
    },
    enterRole: function() {
      this.CHANGE_SETTING_DATA({type: 'defaultRoleId', value: this.enterRole})
    }
  },
  methods:{
    ...mapMutations('roomSetting', ['CHANGE_SETTING_DATA']),
    setDefault(){
      this.isCameraOn = this.params.defaultRoleCamera ? !this.isCameraOn : this.isCameraOn;
      this.isMicOn = this.params.defaultRoleMic ? !this.isMicOn : this.isMicOn;
      this.isResetRole = this.params.defaultRoleReset ? !this.isResetRole : this.isResetRole;
      this.useWaitingRoom = this.params.useWaitingMode ? !this.useWaitingRoom : this.useWaitingRoom;
      if(this.useWaitingRoom){
        this.isDeviceRequired = this.params.isDeviceRequired ? !this.isDeviceRequired : this.isDeviceRequired;
      }

      this.enterRole = this.params.defaultRoleId;

      if(this.params.defaultDeviceType == null) {
        this.joinDevice = 'all';
      } else {
        this.joinDevice = this.params.defaultDeviceType;
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.room-setting-join-component{
  padding: 20px;
  white-space: pre-line;
}

</style>